"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDTH_MOBILE = exports.WIDTH_DESKTOP = exports.BREAKPOINT = void 0;
const theme_1 = require("@zapier/theme");
const { sizes } = theme_1.Screen;
exports.BREAKPOINT = `(max-width: ${sizes.desktop - 1}px)`;
exports.WIDTH_DESKTOP = 450;
exports.WIDTH_MOBILE = 320;
